<template>
    <div class="Services">
        <div class="home-box">
            <menuBox :step="3"></menuBox>
            <div class="text-box">
                <div>nuestro servicio</div>
                <div class="sb-text">No solo brindamos comida y entretenimiento, sino que también brindamos servicios personalizados. Díganos qué necesita y haremos todo lo posible para cumplir y superar sus expectativas.</div>
            </div>
        </div>
        <div class="organization-box">
            <div class="profit-box">
                <img src="../assets/serve-2.png" alt="">
                <div>Comprueba todos los niveles, solo para disfrutar de un sabor delicioso.</div>
                <p>Somos más que una simple empresa de catering, somos un lugar para vivir experiencias de entretenimiento y ocio únicas. Utilizamos ingredientes de alta calidad y servicios profesionales para crear una vida maravillosa para nuestros clientes todos los días. Desde la selección de ingredientes hasta la cocción de cada plato, estamos comprometidos a brindar a los clientes una experiencia gastronómica placentera a través de ingredientes frescos y menús bien diseñados. Nuestra misión es hacer que cada huésped sienta la calidez del hogar a través de un servicio de calidad y un ambiente relajado.</p>
            </div>
            <div class="here-box">
                <div class="item">
                    <img src="../assets/serve-3.png" alt="">
                    <div>Sabores innovadores, experiencias maravillosas:</div>
                    <p>Explora nuestros exclusivos lugares gastronómicos y de entretenimiento, donde cada visita es un viaje lleno de sorpresas y creatividad.</p>
                </div>
                <div class="item">
                    <img src="../assets/serve-4.png" alt="">
                    <div>Excelente reputación y garantía de calidad.</div>
                    <p>Somos más que una simple empresa de catering, somos un lugar para vivir experiencias de entretenimiento y ocio únicas. Utilizamos ingredientes de alta calidad y servicios profesionales para crear una vida maravillosa para nuestros clientes todos los días.</p>
                </div>
                <div class="item">
                    <img src="../assets/serve-5.png" alt="">
                    <div>Innovación creativa, equipo profesional.</div>
                    <p>Nuestro equipo es profesional y entusiasta, siempre centrado en el cliente y le brinda experiencia y servicio de calidad.</p>
                </div>
            </div>
        </div>

        <div class="valuable-box">
            <div class="title">Gustos diversos, disfruta cada momento.</div>
            <div class="sbtitle">Cada plato es el resultado de nuestra cuidada selección, y cada cliente es objeto de nuestro esmerado servicio.</div>
            <div class="list-box">
                <div class="item">
                    <img src="../assets/serve-6.png" alt="">
                    <div>Fiesta de postres, deja que la dulzura florezca en la punta de tu lengua</div>
                    <p>El postre no es sólo un plato, es nuestro compromiso con tu dulce vida. Cada postre combina creatividad y tradición para brindarle disfrute y satisfacción sin fin. Ya sea que esté compartiendo una tarde tranquila con amigos o agregando un postre para el final perfecto de una cena familiar, nuestra selección de postres cuidadosamente seleccionada se convertirá en un recuerdo precioso en su vida.</p>
                </div>
                <div class="item">
                    <img src="../assets/serve-7.png" alt="">
                    <div>Una variedad de frutas para satisfacer tu búsqueda de comida sana y deliciosa.</div>
                    <p>Te presentamos una gama de delicias cuidadosamente elaboradas a base de frutas frescas y diversas. Ya sea una refrescante ensalada de frutas o un maridaje fresco con un jugo, cada sorbo irradia dulzura natural y vitalidad saludable.
                    </p>
                </div>
                <div class="item">
                    <img src="../assets/serve-8.png" alt="">
                    <div>Carnaval de carne, comida deliciosa proviene de ingredientes reales.</div>
                    <p>Seleccionamos cuidadosamente cada pieza de carne para asegurar su frescura y alta calidad, y utilizamos exquisitas técnicas de cocina para presentarle deliciosos platos con rica textura y atractivo aroma.</p>
                </div>
            </div>
        </div>


        <footerBox></footerBox>
    </div>
</template>

<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";

export default {
    name: 'App',
    components: {
        menuBox,
        footerBox,
    },
    data() {
        return {

        }
    },
    mounted() {

    },
    methods: {

    }
}
</script>


<style lang="less" scoped>
.title {
    font-weight: 400;
    font-size: 52px;
    color: #333333;
}

.sbtitle {
    font-weight: 400;
    font-size: 22px;
    color: #656565;
    margin-top: 18px;
}

.home-box {
    height: 550px;
    background: url(../assets/serve-1.png);
    background-size: 100% 100%;
    position: relative;
    z-index: 11;

    .text-box {
        font-weight: 400;
        font-size: 68px;
        color: #FFFFFF;
        text-align: center;
        width: 900px;
        margin: auto;
        margin-top: 100px;

        p {
            font-weight: 400;
            font-size: 22px;
            color: #FFA72C;
            margin-top: 20px;
        }

        .sb-text {
            font-weight: 400;
            font-size: 22px;
            color: #FFFFFF;
            margin-top: 20px;
        }
    }
}

.organization-box {
    padding: 302px 360px;
    background-color: #FFF8EE;
    min-height: 300px;
    margin-top: -100px;
    z-index: -1;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .profit-box {
        width: 850px;

        img {
            width: 760px;
        }

        div {
            font-weight: 400;
            font-size: 52px;
            color: #333333;
            margin-top: 40px;
        }

        p {
            font-weight: 400;
            font-size: 22px;
            color: #656565;
            margin-top: 48px;
        }
    }

    .here-box {
        width: 240px;

        .item {
            margin-top: 40px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;

            img {
                width: 80px;
            }

            div {
                font-weight: 400;
                font-size: 20px;
                color: #333333;
                margin-top: 24px;
                text-align: center;
            }

            p {
                font-weight: 400;
                font-size: 16px;
                color: #333333;
                margin-top: 16px;
                text-align: center;
            }
        }
    }
}

.valuable-box {
    background: url(../assets/serve-9.png) no-repeat;
    background-size: 100% 1210px;
    min-height: 500px;
    margin-top: -160px;
    text-align: center;
    padding: 0px 360px;
    padding-bottom: 150px;

    .title {
        padding-top: 250px;
    }

    .list-box {
        margin-top: 80px;
        display: flex;
        align-items: flex-start;
        justify-content: space-between;

        .item {
            width: 368px;

            img {
                width: 368px;
            }

            div {
                font-weight: 400;
                font-size: 28px;
                color: #333333;
                margin-top: 32px;
            }

            p {
                font-weight: 400;
                font-size: 20px;
                color: #888888;
                margin-top: 32px;
            }
        }
    }
}
</style>